import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

interface Props {
  profile: { phone?: string | null; country?: string | null } | null;
  professional: {
    headline: string | null;
    bio: string | null;
    skills: string[];
    sectors: string[];
    languages: string[];
    years_experience: number | null;
    resume_url: string | null;
    linkedin_url: string | null;
  } | null;
}

const FIELDS = [
  'headline', 'bio', 'skills', 'sectors', 'languages',
  'years_experience', 'resume_url', 'linkedin_url', 'phone', 'country',
] as const;

export function ProfileCompleteness({ profile, professional }: Props) {
  const { t } = useTranslation();

  if (!professional) return null;

  const filled = FIELDS.filter(f => {
    if (f === 'phone') return !!profile?.phone;
    if (f === 'country') return !!profile?.country;
    const val = professional[f as keyof typeof professional];
    if (Array.isArray(val)) return val.length > 0;
    return val != null && val !== '';
  }).length;

  const pct = Math.round((filled / FIELDS.length) * 100);

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium">{t('myProfile.completeness')}</span>
          <span className="text-sm text-muted-foreground">{filled}/{FIELDS.length}</span>
        </div>
        <Progress value={pct} className="h-2" />
        {pct < 100 && (
          <p className="text-xs text-muted-foreground mt-2">{t('myProfile.completenessHint')}</p>
        )}
      </CardContent>
    </Card>
  );
}
